import React from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import DazzedHeadingForGrid from 'components/common/text/DazzedHeadingForGrid'

const useStyles = makeStyles(() => ({
  root: {},
  scoreItem: {
    margin: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))

const ScoreOption = ({ index, icon, fillColor, strokeColor, value }) => {
  const classes = useStyles()

  return (
    <Grid item className={classes.scoreItem} key={index}>
      <Grid item>
        {React.createElement(icon, {
          size: 'small',
          style: { marginRight: 5, marginBottom: 5 },
          fillColor: fillColor,
          strokeColor: strokeColor
        })}
      </Grid>
      <Grid item>
        <DazzedHeadingForGrid
          semibold
          xs={13}
          sm={13}
          md={13}
          lg={15}
          xl={15}
          style={{
            textAlign: 'center',
            paddingBottom: 10
          }}
        >
          {value}
        </DazzedHeadingForGrid>
      </Grid>
    </Grid>
  )
}

export default ScoreOption
